import { Controller } from '@hotwired/stimulus';

const ONFIDO_IFRAME_ALLOW = [
  'camera *',
  'microphone *',
  'geolocation *',
  'clipboard-read *',
  'clipboard-write *',
  'gyroscope *',
  'accelerometer *',
  'magnetometer *',
  'ch-ua-platform-version *',
  'ch-ua-model *',
  'ch-ua-full-version *',
].join('; ');

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String,
    locale: String,
  };

  connect() {
    this.syncModal = new bootstrap.Modal(
      document.getElementById('syncModal'),
      { backdrop: 'static', keyboard: false }
    );
    this.delegatePermissionsOnInsert();
    this.initWidget();
  }

  disconnect() {
    this.permissionsObserver?.disconnect();
  }

  // The widget inserts its iframe after `init` returns, and a frame's
  // permissions policy is fixed when its navigation starts, hence the `src` reset.
  delegatePermissionsOnInsert() {
    this.permissionsObserver = new MutationObserver(() => {
      const frame = this.element.querySelector('iframe');
      if (!frame) return;

      this.permissionsObserver.disconnect();
      frame.setAttribute('allow', ONFIDO_IFRAME_ALLOW);
      frame.setAttribute('src', frame.getAttribute('src'));
    });
    this.permissionsObserver.observe(this.element, { childList: true });
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: this.localeValue,
        isSidebarMenuEnabled: true,
        arePersonalFieldsReadonly: true,
        isWelcomePageEnabled: false,
        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 0),
        onPageChange: () => window.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
      }
    );
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue);

    if (success) {
      url.searchParams.set('status', 'success');
    } else {
      url.searchParams.set('status', 'incomplete');
    }

    if (delay > 0) {
      this.syncModal.show();
    }

    setTimeout(() => {
      window.location.replace(url);
    }, delay);
  }
}
